import { InputSummaryItem } from '../input-summary';
import Utils from '../../util';

export interface UnitValueInterface {
  value: number | null;
  unit: string | null;
}

export class UnitValue {
  value: number | null;
  unit: string | null;

  constructor(param: UnitValueInterface = {
    value: null,
    unit: null
  }) {
    this.value = param?.value ?? null;
    this.unit = param?.unit ?? null;
  }

  static deepCopy(unitValue: UnitValue) {
    let copy;
    if (unitValue) {
      copy = new UnitValue(unitValue);
      return copy;
    }
    throw new Error('unit value deep copy failed');
  }

  hasValues() {
    return (this.unit && Utils.isNumeric(this.value));
  }

  toInputSummaryItem(name: string, path: string[]) {
    // checking for null/undefined to avoid a 0 being a false
    if ((this.value !== null && this.value !== undefined)) {
      const inputItem = new InputSummaryItem();
      inputItem.name = name;
      inputItem.path = path;
      if (this.value !== null && this.value !== undefined) {
        inputItem.value = this.value + '';
      }
      inputItem.unit = this.unit;
      return inputItem;
    }
    return null;
  }
}
